import React from 'react';

export interface MenosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MenosIcon: React.FC<MenosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.334 12.496h14"/>
    </svg>
  );
};

export default MenosIcon;
